import { Box, Divider } from '@factorialco/deprecated-design-system'
import { F0TagRaw, TwoColumnLayout  } from '@factorialco/f0-react'
import { F0TableOfContent } from '@factorialco/f0-react/dist/experimental'
import { motion } from 'framer-motion'

import i18n from 'modules/core/lib/i18n'

import { contentRegistry } from 'modules/trainings/components/content/ContentRegistry'
import { ContentItem } from 'modules/trainings/lib/content/ContentItem'

type TocItem = {
  id: string
  label: string
  onClick: () => void
  disabled?: boolean
  children?: TocItem[]
}

const contentAnimation = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
  transition: { duration: 0.25, ease: 'easeOut' }
}

const ContentConsumer = ({
  tocItems,
  selectedItem,
}: {
  tocItems: TocItem[]
  selectedItem: ContentItem
}) => {
  return (
    <>
      <Divider />
      <TwoColumnLayout
        mainColumnPosition="right"
        sideContent={
          <div>
            <F0TableOfContent
              activeItem={selectedItem?.uuid}
              items={tocItems}
              title={i18n.t('trainings.content.builder.title')}
            />
          </div>
        }
      >
        <motion.div
          key={selectedItem.uuid}
          initial="initial"
          animate="animate"
          exit="exit"
          variants={contentAnimation}
          transition={contentAnimation.transition}
        >
          <Box alignItems="center">
            <Box
              flexDirection="row"
              alignSelf="start"
              height="s64"
            >
              <div>
                <ItemTag item={selectedItem} />
              </div>
            </Box>
            <RenderItem item={selectedItem} />
          </Box>
        </motion.div>
      </TwoColumnLayout>
    </>
  )
}

function ItemTag({ item }: { item: ContentItem }) {
  const icon = contentRegistry.getIconForItem(item)
  const label = contentRegistry.getLabelForItem(item)
  if (!icon || !label)  return null

  return <F0TagRaw icon={icon} text={label} />
}

function RenderItem({ item }: { item: ContentItem }) {
  const ConsumerComponent = contentRegistry.getConsumerForItem(item)
  if (!ConsumerComponent) return null

  return <ConsumerComponent contentItem={item} />
}

export default ContentConsumer
